module.exports = __webpack_public_path__ + "static/modal3-8dd0deb873b21c804f85537280a86b26.png";